import React from "react";
import { Loading } from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import useVendor from "../../useVendor";

interface ModalViewFileProps {
  useCustomHook: ReturnType<typeof useVendor>;
}

const ModalViewFile = ({ useCustomHook }: ModalViewFileProps) => {
  const {
    isViewFile,
    setViewFile,
    docUrl,
    setDocUrl,
    files,
  } = useCustomHook;

  const fileName = files[0]?.file_name || "";

  return (
    <Modal
      isOpen={isViewFile}
      setOpen={() => { setViewFile(false); setDocUrl(""); }}
      title={fileName}
      body={<div style={{
        margin: "-16px",
        width: 700,
        height: "70vh",
      }}>
        {((hasDocUrl, isPdf) => {
          if (hasDocUrl) {
            return <div style={{ padding: 16 }}>
              {(() => {
                if (isPdf) {
                  return <object data={`${docUrl}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&scrollbar=0`} type="application/pdf" width="100%" height="500px">
                    <p>Unable to display PDF file. <a href={docUrl}>Download</a> instead.</p>
                  </object>;
                } return <img
                  src={docUrl}
                  style={{
                    width: 700 - 16 - 16,
                    height: "calc(70vh - 16px - 16px)",
                    objectFit: "contain",
                  }}
                />;
              })()}
            </div>;
          } return <Loading variant="circular" />;
        })(docUrl, fileName.split(".").pop()?.toLowerCase().includes("pdf"))}
      </div>}
      width={700}
    />
  );
};

export default ModalViewFile;
